<template>
  <nav class="navbar navbar-expand-md navbar-light bg-white"
       :class="{ 'open-sidebar': openSidebar }">
    <div class="container-fluid" >
      <router-link :to="{ name: user ? 'home' : '' }" class="navbar-brand mr-0">
        {{ appName }}
      </router-link>

      <button class="navbar-toggler" type="button" v-on:click="toggleSidebar">
        <span class="navbar-toggler-icon"/>
      </button>

      <div id="navbarToggler" class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <!-- Authenticated -->
          <li v-if="user" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle text-dark"
               href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <img src='/img/base/avatar.png' class="rounded-circle profile-photo mr-1">
              {{ user.name }}
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              <a href="#" class="dropdown-item pl-3" @click.prevent="logout">
                {{ $t('logout') }}
              </a>
            </div>
          </li>
          <!-- Guest -->
          <template v-else>
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" class="nav-link d-none" active-class="active">
                {{ $t('login') }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="trans-background" v-on:click="toggleSidebar"></div>
  </nav>
</template>

<script>
  import { mapGetters } from 'vuex'
  import LocaleDropdown from './LocaleDropdown'

  export default {
    components: {
      LocaleDropdown
    },

    data: () => ({
      appName: window.config.appName,
      openSidebar: false
    }),

    computed: mapGetters({
      user: 'auth/user'
    }),

    methods: {
      async logout () {
        // Log out the user.
        await this.$store.dispatch('auth/logout')

        // Redirect to login.
        this.$router.push({ name: 'login' })
      },
      toggleSidebar() {
        this.openSidebar = !this.openSidebar
      }
    }
  }
</script>

<style scoped>
  .profile-photo {
    width: 2rem;
    height: 2rem;
    margin: -.375rem 0;
  }

  .navbar-light .navbar-brand,
  .navbar-light .navbar-brand:hover {
    color: rgba(0, 0, 0, 0.9);
    text-decoration: none;
  }

  .nav-item .dropdown-menu a,
  .nav-item .dropdown-menu a:hover {
    font-size: 16px;
    color: #16181b;
  }

  .theme--light.v-list .v-list__tile--link,
  .theme--light.v-list .v-list__tile--link:hover,
  .md-theme-default a:not(.md-button) {
    color: rgba(0,0,0,.87);
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/Navbar.vue